import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
// import classnames from 'classnames';
import _ from 'lodash'

import CustomDate from '../../../../../../../../../../../components/CustomDate'
import Currency from '../../../../../../../../../../../components/Currency'
import Money from '../../../../../../../../../../../components/TableCell/components/Money'
import Link from '../../../../../../../../../../../components/TableCell/components/Link'

import Participants from './components/Participants'

import { LOCALE_PREFIX } from '../../constants'
import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
@injectIntl
export default class Table extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        entId: PropTypes.string.isRequired,
        filter: PropTypes.object,
        handleTableChange: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
        isLoading: PropTypes.bool.isRequired,
        level: PropTypes.string,
        locale: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        sorted: PropTypes.array,
    }

    onTableChange = (changeData) => {
        const { handleTableChange } = this.props

        handleTableChange(changeData)
    }

    getColumnsDefinition = () => {
        const { filter, intl } = this.props

        return [
            {
                accessor: 'name',
                Header: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.contractName` })}`,
                Cell: (value) => (
                    <Link
                        label={_.get(value, 'value', '')}
                        url={_.get(value, 'original.url', '')}
                        showIcon
                        iconType={'external'}
                        openOnNewTab
                    />
                ),
            },
            {
                // Needed for filter
                // Has to match a key in filter.availableParameters
                id: 'source',
                accessor: 'sourceIso',
                Header: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.source` })}`,
                width: 70,
                Cell: (value) => (
                    <span>
                        <div
                            style={{ marginRight: '2px' }}
                            className={`flag-icon flag-icon-${_.get(value, 'value').toLowerCase()}`}
                        />
                        {_.get(value, 'value')}
                    </span>
                ),
                filterable: true,
                filter: {
                    type: 'VALUE',
                    value: _.map(_.get(filter, 'availableParameters.source.availableValues', []), (x) => ({
                        value: _.get(x, 'value', null),
                        item: _.get(x, 'title', null),
                    })),
                },
            },
            {
                accessor: 'participants',
                Header: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.numberOfParticipants` })}`,
                width: 100,
            },
            {
                accessor: 'money',
                Header: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.value` })}`,
                sortable: true,
                width: 125,
                Cell: (value) => <Money value={_.get(value, 'value')} emptyValue={'-'} showCurrency={false} />,
            },
            {
                accessor: 'money',
                Header: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.currency` })}`,
                width: 100,
                Cell: ({ value }) => <Currency currency={value?.currency} />,
            },
            {
                accessor: 'money.description',
                Header: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.moneyType` })}`,
                width: 150,
            },
            {
                // Needed for filter
                // Has to match a key in filter.availableParameters
                id: 'role',
                accessor: 'subjectRole',
                Header: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.companyRole` })}`,
                width: 275,
                filterable: true,
                filter: {
                    type: 'VALUE',
                    value: _.map(_.get(filter, 'availableParameters.role.availableValues', []), (x) => ({
                        value: _.get(x, 'value', null),
                        item: _.get(x, 'title', null),
                    })),
                },
            },
            {
                accessor: 'signDate',
                Header: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.signed` })}`,
                sortable: true,
                width: 100,
                Cell: (value) => (
                    <span>
                        <CustomDate
                            date={_.get(value, 'value.value', null)}
                            precision={_.get(value, 'precision', 'days')}
                        />
                    </span>
                ),
            },
            {
                accessor: 'publicationDate',
                Header: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.published` })}`,
                sortable: true,
                width: 100,
                Cell: (value) => (
                    <span>
                        <CustomDate
                            date={_.get(value, 'value.value', null)}
                            precision={_.get(value, 'precision', 'days')}
                        />
                    </span>
                ),
            },
        ]
    }

    render() {
        const { module, block, level, entId, customData, data, filter, isLoading, pagination, sorted, intl, locale } =
            this.props

        if (_.isEmpty(data) && _.isEmpty(_.get(filter, 'activeFilters', {}))) return null

        return (
            <div className={'contracts-table-container'}>
                <FilterTable
                    id={`contracts-filter-table-${entId}`}
                    data={data ?? []}
                    itemIdentifier={'id'}
                    loading={isLoading}
                    columnsDefinition={this.getColumnsDefinition()}
                    settings={{
                        pagination,
                        sorted,
                        filtered: (filter?.activeFilters ?? []).map((actFilter) => ({
                            id: actFilter?.id,
                            value: actFilter?.value || [],
                        })),
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    selectable={false}
                    SubComponent={(row) => (
                        <div className={'contracts-sub-component-container'}>
                            <Participants
                                docId={_.get(row, 'row.original.id')}
                                row={_.get(row, 'row.original')}
                                entId={entId}
                                module={module}
                                customData={customData}
                                block={block}
                                level={level}
                                locale={locale}
                            />
                        </div>
                    )}
                    onTableChange={this.onTableChange}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                        filter: {
                            valueTitle: intl.formatMessage({ id: 'global.valueTitle' }),
                            fulltextTitle: intl.formatMessage({ id: 'global.fulltextTitle' }),
                        },
                    }}
                    expandOnRowClick
                />
            </div>
        )
    }
}
